var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.19,
    height: 26.799,
    viewBox: "0 0 29.19 26.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.829,12.617H5.048V9.259A6.218,6.218,0,0,0,8.014,5.175H0V0H13.994a14.357,14.357,0,0,1,.256,2.731,12.536,12.536,0,0,1-4.421,9.887Z",
    transform: "translate(14.94 10.949)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,3.456V0H4.935a8.834,8.834,0,0,0,8.332,5.536,9.584,9.584,0,0,0,5.05-1.282L23.1,7.606a15.118,15.118,0,0,1-9.837,3.239A15.082,15.082,0,0,1,0,3.456Z",
    transform: "translate(1.609 15.954)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M1.589,12.1a12.305,12.305,0,0,1,0-12.1H6.551V3.469a7.319,7.319,0,0,0,0,5.157Z",
    transform: "translate(0 7.404)",
    fill: "#fbbc04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M4.934,10.845,0,7.391A15.1,15.1,0,0,1,13.275,0a15.162,15.162,0,0,1,9.94,3.488L18.973,7.317h0a8.569,8.569,0,0,0-5.7-2.01,8.834,8.834,0,0,0-8.34,5.538Z",
    transform: "translate(1.609 0)",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/iconGoogle.07e16ea30ce9fd127dbc4afd163319b9.svg";
export { ForwardRef as ReactComponent };